var _mask, _g, _mask2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlindPickup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "drawerAlert",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 18,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.525 6.41666H5.25625C4.26625 6.41666 3.44125 7.33333 3.44125 8.25L2.9875 14.6667H17.0125L16.6 8.25C16.435 7.33333 15.61 6.41666 14.785 6.41666H9.175V5.5H11.65V2.75H5.05V5.5H7.525V6.41666ZM18.25 15.5832H1.75V19.2499H18.25V15.5832ZM10.825 8.25V10.0833H14.95V8.25H10.825ZM5.04999 9.16667V8.25H6.69998V9.16667H5.04999ZM7.52503 8.25V9.16667H9.17503V8.25H7.52503ZM5.04999 10.9999V10.0833H6.69998V10.9999H5.04999ZM7.52503 10.0833V10.9999H9.17503V10.0833H7.52503ZM5.04999 12.8333V11.9166H6.69998V12.8333H5.04999ZM7.52503 11.9166V12.8333H9.17503V11.9166H7.52503ZM5.875 4.5833V3.66663H10.825V4.5833H5.875Z",
    fill: "#5D6B72"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#drawerAlert)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 2H1V20H10.0186C10.3102 16.091 13.996 13 18.5 13C18.6678 13 18.8346 13.0043 19 13.0128V2Z",
    fill: "white"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "drawerArrow",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 14,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4262 13.6019V10.75L23.4169 15.7407L18.4262 20.7315V17.8083C14.8613 17.8083 12.366 18.9491 10.5836 21.4444C11.2965 17.8796 13.4354 14.3148 18.4262 13.6019Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#drawerArrow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 12,
    transform: "matrix(-1 0 0 1 24.0002 10)",
    fill: "#D0021B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlindPickup);
export default __webpack_public_path__ + "static/media/blind-pickup.95775ac7.svg";
export { ForwardRef as ReactComponent };